import React from "react";
import { TableContext } from "./contextProvider";

function useTableContext() {
    const context = React.useContext(TableContext);

    return context;
}

export default useTableContext;
